import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearCookies } from "../../requestors/loginRequestor";
import {
  clearCustomAuthTokens,
  getCustomAuthTokens,
} from "../../features/auth/LoginBox";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logoutAsync = async () => {
      try {
        // Get refresh token from storage
        const authTokens = getCustomAuthTokens();
        const accessToken = authTokens?.access_token;

        // Call backend to revoke the refresh token
        if (accessToken) {
          const revokeResponse = await fetch(
            `${import.meta.env.VITE_API_URL}/api/apps/auth/revoke-token`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
              },

              credentials: "include",
            },
          );

          if (revokeResponse.ok) {
            console.log("✅ Refresh token revoked successfully");
          } else {
            console.warn("⚠️ Token revocation failed, continuing with logout");
          }
        }
      } catch (err) {
        console.error("Failed to revoke token:", err);
      }

      console.log("[AUTH][datasurfr][Logout/index.tsx] Logout flow started");

      // [AUTH] clear localStorage
      console.warn("[AUTH][datasurfr][Logout/index.tsx] Clearing localStorage");
      localStorage.clear();

      // [AUTH] clear sessionStorage
      console.warn("[AUTH][datasurfr][Logout/index.tsx] Clearing sessionStorage");
      sessionStorage.clear();

      // [AUTH] delete non-httpOnly cookies
      const deleteCookie = (name: string) => {
        console.warn(`[AUTH][datasurfr][Logout/index.tsx] Deleting cookie: ${name}`);
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Lax`;
      };

      deleteCookie("accessToken");
      deleteCookie("refreshToken");

      try {
        console.log("[AUTH][datasurfr][Logout/index.tsx] Calling clearCookies() — server httpOnly clear");
        const response = await clearCookies();
        console.log("✅ Tokens cleared successfully:", response);
      } catch (err) {
        console.error("❌ Failed to clear tokens:", err);
      }

      // [AUTH] clear custom auth tokens from sessionStorage
      console.warn("[AUTH][datasurfr][Logout/index.tsx] Clearing custom auth tokens");
      clearCustomAuthTokens();

      // [AUTH] redirect to Cognito logout
      const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
      const logoutUri = import.meta.env.VITE_COGNITO_LOGOUT_URL;
      const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;

      if (!clientId || !logoutUri || !cognitoDomain) {
        console.error(
          "[AUTH][datasurfr][Logout/index.tsx] Missing Cognito env vars — falling back to '/'",
        );
        window.location.href = "/";
        return;
      }

      const cognitoLogoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
      console.warn("[AUTH][datasurfr][Logout/index.tsx] Redirecting to Cognito logout:", cognitoLogoutUrl);
      window.location.href = cognitoLogoutUrl;
    };

    logoutAsync();
  }, [navigate]);

  return <p>Logging out...</p>;
};

export default Logout;
